// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Box } from '@mui/material'; // <-- Import Box

// Import your actual page components
import LandingPage from './LandingPage';
// import DispatcherPage from './DispatcherPage';
import FlightBreakdownPage from './FlightBreakdown';
import Flights from './Flights';
import UserSettings from './UserSettings';
import FlightDataPage from './FlightDataPage';

// Import NavBar here
import NavBar from './NavBar'; // <-- Import NavBar

function App() {
  return (
    <Router>
      {/* Render NavBar ONCE, outside Routes */}
      <NavBar />

      {/* Render the offset Box ONCE, below NavBar */}
      {/* This pushes all route content down globally */}
      <Box sx={{ height: 84 }} />

      {/* Routes will render the specific page content BELOW the offset */}
      <Routes>
        {/* Redirect base path '/' to the Flight Breakdown page */}
        <Route path="/" element={<Navigate replace to="/breakdown" />} />

        {/* Define routes for your application pages */}
        <Route path="/landing" element={<LandingPage />} />
        {/* <Route path="/dispatcher" element={<DispatcherPage />} /> */}
        <Route path="/breakdown" element={<FlightBreakdownPage />} />
        <Route path="/flights" element={<Flights />} />
        <Route path="/user-settings" element={<UserSettings />} />
        <Route path="/flight-data" element={<FlightDataPage />} />

        {/* Optional: Add a catch-all 404 Not Found route */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
